import { render, staticRenderFns } from "./ForgotPin.vue?vue&type=template&id=bd20479a&scoped=true&"
import script from "./ForgotPin.vue?vue&type=script&lang=js&"
export * from "./ForgotPin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd20479a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/projects/tus-cc-auth/tus-cc-auth/frontend/tusauth/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VFlex,VForm,VLayout})
